function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.0123 9.16436C28.6749 7.72145 34.3374 7 40 7C45.6626 7 51.3251 7.72146 56.9877 9.16437C58.7598 9.61593 60 11.2118 60 13.0405C60 20.1126 60 29.2658 60 40.5C60 57.2814 52.4998 70.12 43.9953 73.2602C42.6796 73.7461 37.3223 73.7197 36.0075 73.1907C27.5019 69.7688 20 55.9516 20 40.5071C20 30.0118 20 20.8562 20 13.0405C20 11.2118 21.2402 9.61592 23.0123 9.16436Z",
  fill: "#27223F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M55.5 18H24.5C24.2239 18 24 18.2239 24 18.5V35.5C24 35.7761 24.2239 36 24.5 36H55.5C55.7761 36 56 35.7761 56 35.5V18.5C56 18.2239 55.7761 18 55.5 18Z",
  fill: "#535285"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M37.5 40H24.5C24.2239 40 24 40.2239 24 40.5V45.5C24 45.7761 24.2239 46 24.5 46H37.5C37.7761 46 38 45.7761 38 45.5V40.5C38 40.2239 37.7761 40 37.5 40Z",
  fill: "#6F6E98"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M55.5 40H42.5C42.2239 40 42 40.2239 42 40.5V45.5C42 45.7761 42.2239 46 42.5 46H55.5C55.7761 46 56 45.7761 56 45.5V40.5C56 40.2239 55.7761 40 55.5 40Z",
  fill: "#6F6E98"
});

var SvgTrezor = function SvgTrezor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrezor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trezor.9e0c663d.svg";
export { ForwardRef as ReactComponent };